<template>
	<div class="module_page page_content institution" aria-label="Institution Package view content page">

    	<div class="row page-heading">
      		<div class="col-8 input module_heading" role="heading" aria-level="1">
        		<span class="module_icon ic-inst"></span>
        		<label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}<span v-if="packageTitle">:: {{packageTitle}}</span></label>
      		</div>
      		<div class="col-4 btn_container">
            <b-btn @click="doneClicked">done</b-btn>
            <b-btn @click="saveClicked">save</b-btn>
        		<b-btn @click="cancelClicked">cancel</b-btn>
      		</div>
    	</div>

	    <div class="page_content_container">

	      	<institution-menu :uuid="uuid" :active="'packages'"></institution-menu>

			<div class="row pg_content">
	      	<div class="col-12 edit_pkg_details">

	        	<div v-if="packageToEdit && packageToEdit.formattedFeatures" class="col-12">
	          		<template v-for="feature in packageToEdit.formattedFeatures">

	          			<div class="row section">
		          			<div class="col-12">

			          			<div class="section_header">
			            			<div class="icon_container">
			              				<b-btn v-b-toggle="'flagContainer_' + feature.featureId">
			                				<span class="collapsed ico-remove_circle1" aria-label="collapse"></span>
			                				<span class="expand ico-add_circle" aria-label="expand"></span>
			              				</b-btn>
			            			</div>
			            			<div class="entity_title">{{feature.title}}</div>
                        <template v-if="isSuperAdmin || feature.title !='Allow for switching models'">
			            			<switches v-model="featureMap[feature.featureId].isEnabled" :disabled="isDisabled(feature)" text-enabled="Yes" text-disabled="No"></switches>
                        </template>
                        <template v-else>
                            <div class="feature_info" v-if="featureMap[feature.featureId].isEnabled">
                              Enabled
                            </div>
                            <div class="feature_info" v-else>
                              Disabled
                            </div>

                        </template>
			            			<div class="feature_info">
			            				<input v-if="showFeatureLabelInput(feature.featureId)" v-model="featureMap[feature.featureId].label" :disabled="isDisabled(feature)"></input>
										<b-btn v-if="isSuperAdmin && featureMap[feature.featureId].isDisabled" @click="featureMap[feature.featureId].isDisabled = false">enable</b-btn>
			            				<b-btn v-else-if="isSuperAdmin && !featureMap[feature.featureId].isDisabled" @click="featureMap[feature.featureId].isDisabled = true">disable</b-btn>
			            			</div>


			            			<div class="head_info">
			            				<span :id="'featureInfo_' + feature.featureId" class="exclamation-circle"><span class="ico-error"></span></span>
			            				<b-popover :target="'featureInfo_' + feature.featureId" triggers="hover" :title="feature.description"></b-popover>
			            			</div>
			            		</div>

			            		<div class="section_content">
			            			<b-collapse v-if="feature.flagNames.length > 0" visible :id="'flagContainer_' + feature.featureId">
					              		<div>
					                		<b-input-group>
						                  		<!-- NOTE: using b-form-checkbox group pulls in custom-control-input class from defaulTheme.min.css
						                        which has opacity set to 0, and absolute position so the checkboxes aren't visible -->
						                  		<!-- <b-form-checkbox-group plain stacked v-model="feature.flagsSelected" :options="feature.flagNames"/> -->
						                  		<div class="row">
							                  		<template v-for="flagName in feature.flagNames">
							                    		<div :id="'flagInfo_' + flagName" class="flag_info col-xl-6 col-lg-6 col-md-12 col-sm-12">
							                      			<input type="checkbox" v-model="featureMap[feature.featureId].flagMap[flagName].isEnabled" :disabled="isDisabled(feature)">
							                          			{{ flagName }}
							                          			<input v-if="showFlagLabelInput(feature.featureId, flagName)" v-model="featureMap[feature.featureId].flagMap[flagName].label" :disabled="isDisabled(feature)"></input>
							                      			</input>
							                    		</div>
							                  		</template>
						                  		</div>
					              			</b-input-group>
					              		</div>
					            	</b-collapse>
								</div>

			            	</div>
		            	</div>

					</template>
				</div>
			</div>
		</div>
		</div>

	</div>
</template>

<script>
// NOTE: this is added to override the custom-control-input class from defaulTheme.min.css
import '../../../assets/module/sass/institution/editInstitutionPackage.scss'
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'
import _ from 'lodash'

export default {
  name: 'editInstitutionPackage',
  props: ['uuid', 'packageId'],
  components: {
    InstitutionMenu,
    InstitutionHeader
  },
  data: () => {
    return {
      errors: [],
      featureMap: {},
      userObject: JSON.parse(localStorage.getItem('userobj')),
      superAdminPermissionName: 'SUPERADMIN_PERMISSION',
      selectedPackageFeatures: []
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    ...mapActions([
      'loadLibrariesForUser',
      'loadInstitutionDetail',
      'loadInstitutionPackage',
      'storeInstitution',
      'loadLogDashboardActivity',
      'loadFeaturesByPackageId'
    ]),
    loadData () {
      const institutionId = this.institutionId
      this.loadInstitutionDetail(institutionId)
      this.loadInstitutionPackage({uuid: institutionId, isAggregated: false})
      if (this.isSuperAdmin) {
        this.loadFeaturesByPackageId(this.packageId).then(features => {
          this.selectedPackageFeatures = features
        })
      }
    },
    cancelClicked () {
      return this.$router.push({ name: 'institutionPackages', params: { uuid: this.uuid } })
    },
    saveClicked () {
      this.saveInstitutionObject()
    },
    async doneClicked () {
      await this.saveInstitutionObject()
      return this.$router.push({ name: 'institutionPackages', params: { uuid: this.uuid } })
    },
    async saveInstitutionObject () {
      let institution = this.institution
      let editedPackages = this.packageListToSave
      const institutionData = {
        uuid: institution.uuid,
        title: institution.title,
        level: institution.level,
        description: institution.description,
        type: institution.type,
        orgType: institution.orgType,
        uri: institution.uri,
        address: institution.address,
        phonenumber: institution.phonenumber,
        faxnumber: institution.faxnumber,
        openId: institution.openId,
        logo: institution.logo,
        autoProvision: institution.autoProvision,
        autoProvisionRole: institution.autoProvisionRole,
        autoTaggingEnable: institution.autoTaggingEnable,
        courseDiscoveryConfigurationEnable: institution.courseDiscoveryConfigurationEnable,
        createPersonProfile: institution.createPersonProfile,
        customLandingPageViewer: institution.customLandingPageViewer,
        debugSearchRelevance: institution.debugSearchRelevance,
        employmentDataProvider: institution.employmentDataProvider,
        enableDashboard: institution.enableDashboard,
        enableExplore: institution.enableExplore,
        guestUserSessionCount: institution.guestUserSessionCount,
        lmsConnectorPackage: institution.lmsConnectorPackage,
        mc3Integration: institution.mc3Integration,
        nlpSearchEnable: institution.nlpSearchEnable,
        packages: editedPackages,
        pollingTimeMessages: institution.pollingTimeMessages,
        pollingTimeNotifications: institution.pollingTimeNotifications,
        sharePlanningStream: institution.sharePlanningStream,
        showDefaultLandingPage: institution.showDefaultLandingPage,
        showDuplicateContent: institution.showDuplicateContent,
        streamPackage: institution.streamPackage,
        semesterMap: institution.semesterMap,
        yearMap: institution.yearMap,
        currentSemester: institution.currentSemester,
        emailRecipients: institution.emailRecipients,
        emailSender: institution.emailSender
      }
      this.showLoader()
      let response = await this.storeInstitution(institutionData)
      await this.loadInstitutionPackage({uuid: this.institutionId, isAggregated: false})
      this.hideLoader()
      let isSuccessful = this.isSuccessfulResponse(response)
      let message = isSuccessful ? 'Successfully updated Package' : 'Unable to update Package'
      let notify = isSuccessful ? this.notifySuccess : this.notifyFailure
      notify(message + ' \'' + this.packageToEdit.title + '\'')
    },
    showLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.show()
      }
    },
    hideLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.hide()
      }
    },
    isSuccessfulResponse (response) {
      return response && response.uuid
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    },
    showFeatureLabelInput (featureId) {
      let feature = this.featureMap[featureId]
      if (this.isSuperAdmin) {
        return feature.isEnabled
      }
      return feature.isEnabled && feature.label
    },
    showFlagLabelInput (featureId, flagName) {
      let flag = this.featureMap[featureId].flagMap[flagName]
      if (this.isSuperAdmin) {
        return flag.isEnabled
      }
      return flag.isEnabled && flag.label
    },
    buildFeatureFromMap (featureId) {
      let editedFeature = this.featureMap[featureId]
      let featureToSave = {
        featureId: featureId,
        title: editedFeature.title,
        description: editedFeature.description,
        label: editedFeature.label,
        thumbnailURI: editedFeature.thumbnailURI,
        style: editedFeature.style,
        features: editedFeature.features,
        enabled: editedFeature.isEnabled,
        disabled: editedFeature.isDisabled
      }
      let editedFlags = []
      let flagMap = editedFeature.flagMap
      editedFeature.flagNames.forEach(flagName => {
        let editedFlag = flagMap[flagName]
        editedFlags.push({
          title: editedFlag.title,
          label: editedFlag.label,
          description: editedFlag.description,
          enabled: editedFlag.isEnabled
        })
      })
      featureToSave.flags = editedFlags
      return featureToSave
    },
    isDisabled (feature) {
      if (this.isSuperAdmin === true) {
        return false
      }
      let featureMap = this.featureMap
      let featureId = feature.featureId
      if (!featureMap || !featureMap[featureId]) {
        return false
      }
      return featureMap[featureId].isDisabled === true
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'packages': state => state.institution.packages,
      'permission': state => state.user.permission
    }),
    isSuperAdmin () {
      let userObject = this.userObject
      let permission = userObject.permission || this.permission
      return permission.name === this.superAdminPermissionName
    },
    institutionId () {
      let uuid = this.uuid
      if (!uuid || uuid.length <= 0) {
        uuid = localStorage.getItem('institutionId') || JSON.parse(localStorage.getItem('userobj')).institutionId
      }
      return uuid
    },
    packageTitle () {
      if (this.packageToEdit && this.packageToEdit.title) {
        let title = this.packageToEdit.title
        return (title.indexOf('Package') !== -1) ? title : (title + ' Package')
      }
      return ''
    },
    packageToEdit () {
      let packageId = this.packageId
      let packages = this.packages
      let target = {}
      packages.forEach(packageObject => {
        if (packageObject.packageId === packageId) {
          target = _.cloneDeep(packageObject)
        }
      })
      if (!target || !target.features || target.features.length <= 0) {
        return target
      }
      let formattedFeatures = []
      let featureMap = {}
      target.features.forEach(feature => {
        let formattedFeature = _.cloneDeep(feature)
        let flagNames = []
        let flagMap = {}
        if (formattedFeature.flags) {
          formattedFeature.flags.forEach(flag => {
            let flagName = flag.title
            flagNames.push(flagName)
            flagMap[flagName] = {
              title: flag.title,
              isEnabled: flag.enabled === true,
              label: flag.label || '',
              description: flag.description || ''
            }
          })
          // Show newly added flags in the feature to SuperAdmin
          if (this.selectedPackageFeatures.length > 0) {
            let dbFeature = _.find(this.selectedPackageFeatures, (dbFeature) => {
              return (formattedFeature.featureId === dbFeature.featureId)
            })
            if (dbFeature && dbFeature.flags) {
              dbFeature.flags.forEach(flag => {
                let title = flag.title
                if (!_.includes(flagNames, title)) {
                  flagNames.push(title)
                  flagMap[title] = {
                    title: title,
                    isEnabled: flag.enabled === true,
                    label: flag.label || '',
                    description: flag.description || ''
                  }
                }
              })
            }
          }
        }
        formattedFeature.flagMap = flagMap
        formattedFeature.flagNames = flagNames
        formattedFeatures.push(formattedFeature)
        featureMap[feature.featureId] = {
          feature: formattedFeature,
          isEnabled: feature.enabled === true,
          isDisabled: feature.disabled === true,
          title: feature.title,
          label: feature.label || '',
          description: feature.description || '',
          flagMap: flagMap,
          flagNames: flagNames
        }
      })
      // Show newly added features in the package to SuperAdmin
      if (this.selectedPackageFeatures.length > 0) {
        this.selectedPackageFeatures.forEach(feature => {
          let formattedFeature = _.cloneDeep(feature)
          let flagNames = []
          let flagMap = {}
          let featureIds = Object.keys(featureMap)
          if (!_.includes(featureIds, feature.featureId)) {
            if (feature.flags) {
              feature.flags.forEach(flag => {
                let flagName = flag.title
                flagNames.push(flagName)
                flagMap[flagName] = {
                  title: flag.title,
                  isEnabled: flag.enabled === true,
                  label: flag.label || '',
                  description: flag.description || ''
                }
              })
            }
            formattedFeature.flagMap = flagMap
            formattedFeature.flagNames = flagNames
            formattedFeatures.push(formattedFeature)
            featureMap[feature.featureId] = {
              feature: formattedFeature,
              isEnabled: feature.enabled === true,
              isDisabled: feature.disabled === true,
              title: feature.title,
              label: feature.label || '',
              description: feature.description || '',
              flagMap: flagMap,
              flagNames: flagNames
            }
          }
        })
      }
      this.featureMap = featureMap
      target.formattedFeatures = formattedFeatures
      return target
    },
    packageListToSave () {
      let packageList = []
      let packages = this.packages
      let packageToEdit = this.packageToEdit

      // add every non-edited package back into the list
      packages.forEach(packageObject => {
        if (packageObject.packageId !== packageToEdit.packageId) {
          packageList.push({
            packageId: packageObject.packageId,
            title: packageObject.title,
            description: packageObject.description,
            features: packageObject.features,
            thumbnailURI: packageObject.thumbnailURI
          })
        }
      })
      const editedPackage = {
        packageId: packageToEdit.packageId,
        title: packageToEdit.title,
        description: packageToEdit.description,
        thumbnailURI: packageToEdit.thumbnailURI
      }

      let editedFeatures = []
      let buildFeatureFromMap = this.buildFeatureFromMap
      Object.keys(this.featureMap).forEach(featureId => {
        editedFeatures.push(buildFeatureFromMap(featureId))
      })
      editedPackage.features = editedFeatures

      packageList.push(editedPackage)
      return packageList
    }
  }
}
</script>

<style scoped>
.input-group {
  z-index: 2;
}

.hidden-container {
  visibility: hidden;
  height: 1px;
}

.heading {
  font-size: 20px;
}

.label {
  font-size: 20px;
  font-weight: bold;
}

.input-group {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/EditInstitutionPackage.vue